import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { LocationResponse } from '../../location-evaluation/models/Location-response';
import { LocationRequest } from '../../location-evaluation/models/Location-request';
import { Api, ApigatewayService } from 'src/app/common/services/apigateway.service';

@Injectable({
  providedIn: 'root',
})
export class LocationEvaluationService {
  private COUNTRY = env.COUNTRY;

  public isRunning$ = new Subject<boolean>();

  constructor(
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService,
    private apigatewayService: ApigatewayService
  ) {}

  // private bestApi = this.apigatewayService.getBestApiGateway();
  // private ARTICO_API_BASE_URL = `${this.bestApi}${env.ARTICO_API_BASE_URL}/api/v1`;
  private ARTICO_API_BASE_URL = `${this.apigatewayService.getApiUrl(Api.ARTICO)}/api/v1`;


  running() {
    this.isRunning$.next(true);
  }

  notRunning() {
    this.isRunning$.next(false);
  }

  evaluateLocation(data: LocationRequest): Observable<LocationResponse> {
    const URL = `${this.ARTICO_API_BASE_URL}/web/modular/${
      this.COUNTRY
    }/insuredmatter/validate?codEmpresa=${this.COUNTRY.toUpperCase()}`;
    const headers = this.getHeader();

    return this.httpClient.post<LocationResponse>(URL, data, { headers });
  }

  private getHeader(): HttpHeaders {
    const token = this.localStorageService.get('sessionToken');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
